import { useState } from "react";
import { Checkbox } from "../../../../components/Checkbox";
import { Column } from "../../../../components/Column";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Button, ChevronIcon, Content, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import { mapInitialSearch, Search } from "../../../../hooks/usePublications";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import {indices} from "../../../../mocks/indices"
import { TreeSelect } from "../../../../components/TreeSelect";
import useAnalyticsEventTracker from '../../../../hooks/useAnalyticsEventTracker';

interface paramsProps {
  submit(value: Search, page?: number): Promise<void>;
  initialSearch?: string
}

export function Form({ submit, initialSearch = "" }: paramsProps) {
  const gaEventTracker = useAnalyticsEventTracker('Publications Form');

  const [initialType, setInitialType] = useState('text');
  const [finalType, setFinalType] = useState('text');

  const [mainSearch, setMainSearch] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  
  const [author, setAuthor] = useState('');

  const [index, setIndex] = useState('');

  const initialSelect = mapInitialSearch(initialSearch);
  const [selectList, setSelectList] = useState<string[]>(initialSelect);

  const [isFormOpen, setIsFormOpen] = useState(false);

  function selectType(value: boolean, label: string) {
    if(value) {
      setSelectList([...selectList, label])
    } else {
      setSelectList(selectList.filter(item => item !== label));
    }
  }
  
  async function onSubmit(e: any) {
    e.preventDefault();

    const search_temp = {
      author: author,
      buscaLivre: mainSearch,
      initialDate: initialDate,
      finalDate: finalDate,
      types: selectList,
      indice: index
    }
    gaEventTracker('submit', JSON.stringify(search_temp))

    await submit(search_temp, 1);
  }
  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="calc(100% - 54px)" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} hasBorder={false} margin="0" customWidth="calc(46% - 12px)">
        <Content
          onSubmit={onSubmit}
        >
          <Row>
            <Column>
              <Label>Busca Livre</Label>
              <Input
                type="text"
                placeholder="Pesquisar"
                marginBottom="16px"
                value={mainSearch}
                onChange={(value) => setMainSearch(value)}
              />
            </Column>
            <Column>
              <Label>Autor/Organizador</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={author}
                onChange={(value) => setAuthor(value)}
              />
            </Column>
          </Row>
          <Label>Data do documento</Label>
          <Row breakOnMobile={false}>
            <Field marginBottom="6px">
              <Input
                type={initialType}
                placeholder=""
                onFocus={() => setInitialType('date')}
                value={initialDate}
                onChange={(value) => setInitialDate(value)}
              />
            </Field>
            <Divider>A</Divider>
            <Field marginBottom="6px">
              <Input
                type={finalType}
                placeholder=""
                onFocus={() => setFinalType('date')}
                value={finalDate}
                onChange={(value) => setFinalDate(value)}
              />
            </Field>
          </Row>
          <Label>Índice</Label>
          <Field marginBottom="16px">
            <TreeSelect 
              data={indices} 
              marginBottom="0px"
              dropdownMaxHeight="350px"
              value={index}
              onChange={(value: any) => setIndex(value)}
            />
            <ChevronIcon size={24} />
          </Field>
          <Row>
            <Column>
              <Label>Tipo</Label>
              <Field marginBottom="10px">
                <Checkbox label="Livro" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Capítulo de Livro" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Artigo em Periódico" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Relatórios de pesquisa" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Documentos Institucionais" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Anais de Congressos" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Paletras e Apresentações" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Guias e manuais" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Outros" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Formatos da produção" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
            </Column>
            <Column>
              <Label>Formatos da Produção</Label>
              <Field marginBottom="10px">
                <Checkbox label="Texto" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Audiovisual" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Gráficos, Mapas Mentais, Fluxos e Ilustrações" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
              <Field marginBottom="10px">
                <Checkbox label="Áudio" onChange={selectType} forceSelfSelect={true} initialSearchedList={initialSelect} />
              </Field>
            </Column>
          </Row>
          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}